import { Col, Form, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onGetItemList } from "redux/actions";
import { GET_ITEM_CATEGORIES, GET_SUPPLIER_ENDPOINT } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";

const SupplierwiseItemPriceReportFields = ({ initialTableData }) => {
  // States
  const [itemCategoryList, setItemCategoryList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const itemList = useSelector(({ item }) => item.itemList);
  const dispatch = useDispatch();
  // current path
  const currentPath = window.location.pathname;

  // Antd
  const { Option } = Select;

  const getItemCategoryList = useCallback(async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      name: filterValues?.name || "",
    };
    const response = await getData(GET_ITEM_CATEGORIES, false, bodyData);

    if (response && response?.data?.code === 200) {
      setItemCategoryList(response?.data?.data?.data || []);
    }
  }, []);

  const getSupplierList = useCallback(async () => {
    const bodyData = {
      per_page: 1000,
    };
    let res = await getData(GET_SUPPLIER_ENDPOINT, false, bodyData);

    if (res) {
      setSupplierList(res?.data?.data?.data || []);
    }
  }, []);

  useEffect(() => {
    getItemCategoryList();
    getSupplierList();
  }, [getItemCategoryList, getSupplierList]);

  useEffect(() => {
    dispatch(
      onGetItemList({
        page: 1,
        per_page: 10,
      }),
    );
  }, [dispatch]);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Item" name="item_ids">
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Item"
            optionFilterProp="children"
            size="small"
            onSearch={(value) =>
              dispatch(
                onGetItemList({
                  page: 1,
                  per_page: 10,
                  name: value,
                }),
              )
            }
            allowClear
            onClear={() =>
              dispatch(
                onGetItemList({
                  page: 1,
                  per_page: 10,
                }),
              )
            }
          >
            {isArrayAndHasValue(itemList) &&
              itemList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Item Category" name="item_category_ids">
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Item Category(s)"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getItemCategoryList({ name: value })}
            allowClear
            onClear={() => getItemCategoryList()}
          >
            {isArrayAndHasValue(itemCategoryList) &&
              itemCategoryList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Suppliers" name="supplier_id">
          <Select
            showSearch
            placeholder="Select a Supplier"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            size="small"
          >
            {supplierList?.length &&
              supplierList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col className="gutter-row" span={4}>
        <Form.Item label="Description of Goods" name="goods_description">
          <Select placeholder="Description of Goods" style={{ width: "100%" }} size="small">
            <option value="Fabric">Fabric</option>
            <option value="Accessories">Accessories</option>
            <option value="Print">Print</option>
            <option value="Washing">Washing</option>
            <option value="Embroidery">Embroidery</option>
            <option value="Testing">Testing Charge</option>
            <option value="Inspection">Inspection Charge</option>
            <option value="Courier">Courier Charge</option>
            <option value="Portal">Portal Charge</option>
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default SupplierwiseItemPriceReportFields;
